import React from 'react';
import MediaQuery from 'react-responsive';
import { injectIntl } from 'react-intl';
import { Popup, Icon } from 'semantic-ui-react';
import getSymbolFromCurrency from 'currency-symbol-map';
import { classNames } from 'utilities/css';
import DesktopAddOnsRow from './desktop-row';
import MobileAddOnsRow from './mobile-row';
import styles from '../styles-module.css';
import { SMALL_DEVICE_BREAK_POINT } from '../../consts';
import { locale } from '../locale';

const AddOnRow = injectIntl((props) => {
  const { intl, addOn, handleOnAddOnsDelete, handleOnAddOnsStatusChange } = props;
  const rates = addOn?.rates;

  // Deleting is blocked once any rate has sold at least one unit, so an add-on with sales history can
  // never be removed. A rate with no capacity limit still counts as sold when availability hits zero.
  const isDisabled = rates
    ? rates.some(r => r.availability === 0 || (r.capacity != null && r.availability < r.capacity))
    : false;
  // Every rate exhausted means the whole add-on is unavailable, so the active toggle is locked off.
  const isAllSoldOut = rates ? rates.every(r => r.availability === 0) : false;

  const formatPrices = () => {
    return rates?.map((r) => {
      const text = r.price === 0
        ? intl.formatMessage(locale.free)
        : `${getSymbolFromCurrency(addOn?.currency).charAt(0)}${r.price} ${addOn?.currency}`;

      return <div className={styles.option} key={r.id}>{text}</div>;
    });
  }

  const tooltipStyle = {
    borderRadius: '5px',
    background: 'var(--color-ink)',
    padding: '8px 8px',
    maxWidth: '327px',
    left: '20px',
  };

  const formatAvailable = () => {
    const soldRateText = rates?.length === 1
      ? intl.formatMessage(locale.allRatesSold)
      : intl.formatMessage(locale.multiRatesSold);

    return rates?.map(r => {
      let text;
      let style = '';

      if (r.availability === 0) {
        text = `${r.availability}/${r.capacity}`;
        style = styles.soldOutColor;
      }
      else if (!r.availability) {
        text = intl.formatMessage(locale.unlimited);
      }
      else {
        text = `${r.availability}/${r.capacity}`;
      }

      return (<div key={r.id}>
        {
          r.availability === 0
          ? <Popup
              content={soldRateText}
              trigger={
                <div style={{display: 'flex'}}>
                  <Icon className={classNames('universe-error', styles.iconStyle)} />
                  <div className={`${styles.option} ${style}`}>
                    {text}
                  </div>
                </div>
              }
              style={tooltipStyle}
              position="top center"
              inverted
              basic
            />
          : <div className={`${styles.option} ${style}`}>
              {text}
            </div>
        }
        </div>);
    });
  }

  return (
    <div className={`${styles.addOnRow}`}>
      <MediaQuery minWidth={SMALL_DEVICE_BREAK_POINT + 1}>
        <DesktopAddOnsRow
          onAddOnsStatusChange={handleOnAddOnsStatusChange}
          onAddOnsDelete={handleOnAddOnsDelete}
          formatPrices={() => formatPrices()}
          formatAvailable={() => formatAvailable()}
          isDisabled={isDisabled}
          isAllSoldOut={isAllSoldOut}
          {...props}
        />
      </MediaQuery>
      <MediaQuery maxWidth={SMALL_DEVICE_BREAK_POINT}>
        <MobileAddOnsRow
          onAddOnsStatusChange={handleOnAddOnsStatusChange}
          onAddOnsDelete={handleOnAddOnsDelete}
          formatPrices={() => formatPrices()}
          formatAvailable={() => formatAvailable()}
          isDisabled={isDisabled}
          isAllSoldOut={isAllSoldOut}
          {...props}
        />
      </MediaQuery>
    </div>
  )
});

export default AddOnRow;
